/**
 * Chat store - RAG conversation state
 */

import { create } from 'zustand';
import { Citation } from '../types/api';

export interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  citations?: Citation[];
  timestamp: Date;
  confidence?: number;
  mode?: 'compliance' | 'insight';
}

interface ChatState {
  messages: Message[];
  queryMode: 'auto' | 'compliance' | 'insight';
  isLoading: boolean;
  
  addMessage: (message: Message) => void;
  setQueryMode: (mode: 'auto' | 'compliance' | 'insight') => void;
  setLoading: (isLoading: boolean) => void;
  clearMessages: () => void;
}

export const useChatStore = create<ChatState>((set) => ({
  messages: [],
  queryMode: 'auto',
  isLoading: false,
  
  addMessage: (message) => set((state) => ({
    messages: [...state.messages, message],
  })),
  
  setQueryMode: (mode) => set({ queryMode: mode }),
  
  setLoading: (isLoading) => set({ isLoading }),
  
  clearMessages: () => set({ messages: [] }),
}));


